module.exports = __webpack_public_path__ + "img/121.c8f63efe.jpg";